// --bd: Editorial product lightbox JS — IAN-87, v2 IAN-88 — START
document.addEventListener('alpine:init', () => {
  // Two-stage Loewe-style lightbox. State machine: closed -> panel -> fullscreen.
  // The media column + thumbnail rail are rendered server-side (see
  // sections/main-product-editorial.liquid). Items are keyed by media.id.
  Alpine.data('xEditorialLightbox', () => ({
    state: 'closed', // 'closed' | 'panel' | 'fullscreen'
    items: [], // [{ id, el, progress }]

    init() {
      const root = this.$root;

      // Map each column item to its thumbnail's progress line, keyed by media id.
      const cols = Array.from(root.querySelectorAll('.editorial-lightbox__item'));
      const thumbs = Array.from(root.querySelectorAll('.editorial-lightbox__thumb'));
      this.items = cols.map((el) => {
        const id = el.dataset.lbId;
        const thumb = thumbs.find((t) => t.dataset.lbId === id);
        return { id, el, progress: thumb ? thumb.querySelector('.editorial-lightbox__progress') : null };
      });

      // Wire the page-gallery media so a click opens the panel at that item.
      const gallery = root.parentElement.querySelector('[data-editorial-gallery]');
      if (gallery) {
        gallery.querySelectorAll('[data-editorial-media]').forEach((el) => {
          const type = el.dataset.mediaType;
          if (type !== 'image' && type !== 'video' && type !== 'external_video') return;
          el.style.cursor = 'zoom-in';
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.openPanel(el.dataset.mediaId);
          });
        });
      }
    },

    // Desktop = two-stage. Below 1024 the panel IS the full-width view (single stage).
    get isDesktop() {
      return window.matchMedia('(min-width: 1024px)').matches;
    },

    openPanel(mediaId) {
      this.state = 'panel';
      document.body.style.overflow = 'hidden';
      this.$nextTick(() => {
        this.scrollToId(mediaId, 'auto');
        this.$refs.scroll.focus(); // so arrow keys scroll the column
        this.onScroll();
      });
    },

    // Clicking an image toggles the zoom (desktop only — mobile is single stage):
    // panel -> fullscreen (zoom in), or fullscreen -> panel (zoom back down).
    imageClick(mediaId) {
      if (!this.isDesktop) return;
      if (this.state === 'panel') this.enterFullscreen(mediaId);
      else if (this.state === 'fullscreen') this.exitFullscreen(mediaId);
    },

    enterFullscreen(mediaId) {
      if (this.state !== 'panel') return;
      const item = this.items.find((i) => i.id === mediaId);
      if (!item) return;
      this.state = 'fullscreen';
      // Keep the clicked image pinned to the top as the column grows.
      this.$nextTick(() => this.anchorTo(item));
    },

    // fullscreen -> panel. Anchors to the clicked image when one is passed
    // (clicking an image to zoom back down); otherwise to whatever is centered
    // (ESC / × button).
    exitFullscreen(mediaId) {
      if (this.state !== 'fullscreen') return;
      const target = mediaId ? this.items.find((i) => i.id === mediaId) : this.activeItem();
      this.state = 'panel';
      this.$nextTick(() => {
        if (target) this.anchorTo(target);
        this.onScroll();
      });
    },

    back() {
      if (this.state === 'fullscreen') this.exitFullscreen();
      else if (this.state === 'panel') this.close();
    },

    close() {
      this.state = 'closed';
      document.body.style.overflow = '';
    },

    scrollToId(mediaId, behavior = 'smooth') {
      const item = this.items.find((i) => i.id === mediaId);
      if (!item) return;
      this.$refs.scroll.scrollTo({ top: item.el.offsetTop, behavior });
    },

    // The item whose band contains the scroll viewport's center line.
    activeItem() {
      const scroll = this.$refs.scroll;
      const anchor = scroll.scrollTop + scroll.clientHeight * 0.5;
      let active = this.items[0];
      this.items.forEach((i) => {
        if (anchor >= i.el.offsetTop) active = i;
      });
      return active;
    },

    // During the 0.6s width transition, item heights animate; pin the target
    // item's top to the scroll top each frame so it stays anchored. Stop on
    // transitionend (with a safety timeout).
    anchorTo(item) {
      const scroll = this.$refs.scroll;
      const col = this.$refs.col;
      let running = true;
      const step = () => {
        if (!running) return;
        scroll.scrollTop = item.el.offsetTop;
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
      const stop = () => {
        running = false;
        col.removeEventListener('transitionend', stop);
      };
      col.addEventListener('transitionend', stop);
      setTimeout(stop, 800);
    },

    // Scroll-spy: fill the active item's thumbnail progress line in proportion
    // to how far we've scrolled through that one image; blank every other line.
    onScroll() {
      const scroll = this.$refs.scroll;
      const anchor = scroll.scrollTop + scroll.clientHeight * 0.5;
      let activeId = this.items.length ? this.items[0].id : null;
      this.items.forEach((i) => {
        if (anchor >= i.el.offsetTop) activeId = i.id;
      });
      this.items.forEach((i) => {
        if (!i.progress) return;
        if (i.id === activeId) {
          const p = (anchor - i.el.offsetTop) / i.el.offsetHeight;
          i.progress.style.height = Math.max(0, Math.min(1, p)) * 100 + '%';
        } else {
          i.progress.style.height = '0%';
        }
      });
    },
  }));
});
// --bd: Editorial product lightbox JS — END
